"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { usePlayerLook } from "@/lib/profile/hooks";

/* A player's profile background (Profile Customization) behind whatever is
   laid on it, under a wash of the surface colour so the name and tier stay
   readable on any picture and in any theme. Without a chosen background it
   is just the content. */
export function ProfileBanner({
  accountId,
  as: Tag = "span",
  className,
  children,
}: {
  accountId: string | null | undefined;
  /* "span" inside inline hosts (the name card); "div" where it holds a heading. */
  as?: "span" | "div";
  className?: string;
  children: ReactNode;
}) {
  const background = usePlayerLook(accountId).data?.background;

  return (
    <Tag className={cn("relative block overflow-hidden", className)}>
      {background && (
        <>
          {/* eslint-disable-next-line @next/next/no-img-element -- admin uploads are served from the content API */}
          <img src={background} alt="" className="absolute inset-0 h-full w-full object-cover" />
          <span className="absolute inset-0 bg-gradient-to-r from-elevation-1/85 via-elevation-1/55 to-elevation-1/25" />
        </>
      )}
      <Tag className="relative block">{children}</Tag>
    </Tag>
  );
}
